import { ChevronRight } from 'lucide-react';
import { ContextMenu as RadixContextMenu } from 'radix-ui';
import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '../lib/cn';
import { Shortcut } from './kbd';
import { menuItem, menuSurface } from './menu-styles';

export const ContextMenu = RadixContextMenu.Root;
export const ContextMenuTrigger = RadixContextMenu.Trigger;
export const ContextMenuSub = RadixContextMenu.Sub;

export function ContextMenuContent({
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixContextMenu.Content>) {
  return (
    <RadixContextMenu.Portal>
      <RadixContextMenu.Content
        collisionPadding={8}
        className={cn(menuSurface, className)}
        {...props}
      />
    </RadixContextMenu.Portal>
  );
}

export function ContextMenuItem({
  icon,
  shortcut,
  danger = false,
  children,
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixContextMenu.Item> & {
  icon?: ReactNode;
  shortcut?: readonly string[];
  danger?: boolean;
}) {
  return (
    <RadixContextMenu.Item
      className={cn(menuItem, danger && 'text-negative [&_svg]:!text-negative', className)}
      {...props}
    >
      {icon}
      <span className="flex-1 truncate">{children}</span>
      {shortcut && <Shortcut keys={shortcut} />}
    </RadixContextMenu.Item>
  );
}

export function ContextMenuSeparator() {
  return <RadixContextMenu.Separator className="-mx-1 my-1 h-px bg-border-subtle" />;
}

export function ContextMenuSubTrigger({
  icon,
  children,
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixContextMenu.SubTrigger> & { icon?: ReactNode }) {
  return (
    <RadixContextMenu.SubTrigger className={cn(menuItem, className)} {...props}>
      {icon}
      <span className="flex-1 truncate">{children}</span>
      <ChevronRight className="-mr-1" />
    </RadixContextMenu.SubTrigger>
  );
}

export function ContextMenuSubContent({
  className,
  ...props
}: ComponentPropsWithRef<typeof RadixContextMenu.SubContent>) {
  return (
    <RadixContextMenu.Portal>
      <RadixContextMenu.SubContent
        sideOffset={6}
        collisionPadding={8}
        className={cn(menuSurface, 'min-w-40', className)}
        {...props}
      />
    </RadixContextMenu.Portal>
  );
}
